import { Button } from '../ui/Button';

export const ErrorState = ({ message, onRetry }: { message: string, onRetry?: () => void }) => (
  <div className="flex flex-col items-center justify-center p-6 text-center text-danger h-full w-full">
    <p className="mb-4">{message}</p>
    {onRetry && <Button variant="outline" size="sm" onClick={onRetry}>Retry</Button>}
  </div>
);